import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lmw-common-subject-topic-link-button',
  templateUrl: './subject-topic-link-button.component.html',
  styleUrls: ['./subject-topic-link-button.component.scss']
})
export class SubjectTopicLinkButtonComponent implements OnInit {

  @Input() public text: string;
  @Input() public slug: string;
  @Input() public type?: string;
  @Input() public completed?: boolean = false;
  @Input() public iconColour?: string;
  @Input() public requiresSignIn?: boolean;
  @Input() public userSignedIn?: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
